import React, { useState } from 'react';
import { CButton, CFormTextarea, CFormLabel } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilCheckCircle, cilMinus, cilXCircle, cilSave } from '@coreui/icons';

/**
 * FeedbackSemaphore Component
 * Provides a premium "traffic light" feedback UI for item verification.
 */
const FeedbackSemaphore = ({ itemId, initialStatus, initialObservations, onSave }) => {
    // Mapeo bidireccional
    const statusMap = { 'bien': 1, 'mal': 3, 1: 'bien', 3: 'mal' };

    // Convertir estado inicial si es numérico
    const getInitialStatus = () => {
        if (typeof initialStatus === 'number') return statusMap[initialStatus] || 'bien';
        return initialStatus || 'bien';
    };

    const [status, setStatus] = useState(getInitialStatus()); // 'bien', 'mal'
    const [observations, setObservations] = useState(initialObservations || '');
    const [isSaving, setIsSaving] = useState(false);


    const [isSaved, setIsSaved] = useState(false);

    const handleSave = async () => {
        setIsSaving(true);
        const formData = new FormData();
        formData.append('itemIdSenal', itemId);
        formData.append('statusSenal', statusMap[status] || 0);
        formData.append('descripcionSenal', observations);
        
        try {
            await onSave(formData);
            setIsSaved(true);
            setTimeout(() => setIsSaved(false), 3000);
        } finally {
            setIsSaving(false);
        }
    };

    const getStatusStyle = (type) => {
        const isActive = status === type;
        const styles = {
            bien: { 
                bg: isActive ? '#2eb85c' : '#f8f9fa', 
                color: isActive ? '#fff' : '#2eb85c',
                border: '1px solid #2eb85c'
            },
            mal: { 
                bg: isActive ? '#e55353' : '#f8f9fa', 
                color: isActive ? '#fff' : '#e55353',
                border: '1px solid #e55353'
            }
        };
        return styles[type];
    };

    return (
        <div className="feedback-container p-3 rounded-3 border mt-4 bg-white shadow-sm" style={{ borderLeft: '4px solid #131133 !important' }}>
            <CFormLabel className="info-modern-label mb-3">Validación de Auditoría (Humana)</CFormLabel>
            
            <div className="d-flex justify-content-between gap-2 mb-3">
                <CButton 
                    className="flex-grow-1 d-flex flex-column align-items-center gap-1 py-3 transition-all"
                    style={getStatusStyle('bien')}
                    onClick={() => setStatus('bien')}
                >
                    <CIcon icon={cilCheckCircle} size="xl" />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>ES CORRECTO</span>
                </CButton>
                
                <CButton 
                    className="flex-grow-1 d-flex flex-column align-items-center gap-1 py-3 transition-all"
                    style={getStatusStyle('mal')}
                    onClick={() => setStatus('mal')}
                >
                    <CIcon icon={cilXCircle} size="xl" />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>INCORRECTO</span>
                </CButton>
            </div>

            <CFormTextarea
                placeholder="Añade tus comentarios de auditoría aquí..."
                rows={3}
                value={observations}
                onChange={(e) => setObservations(e.target.value)}
                className="mb-3 x-small shadow-none border-1"
                style={{ fontSize: '0.8rem', borderRadius: '10px' }}
            />

            <CButton 
                color={isSaved ? "success" : "dark"} 
                className={`w-100 btn-premium-action d-flex align-items-center justify-content-center gap-2 ${isSaved ? 'animate__animated animate__pulse' : ''}`}
                style={{ 
                    backgroundColor: isSaved ? '#2eb85c' : '#131133', 
                    borderColor: isSaved ? '#2eb85c' : '#131133',
                    transition: 'all 0.3s ease'
                }}
                onClick={handleSave}
                disabled={isSaving || isSaved}
            >
                <CIcon icon={isSaved ? cilCheckCircle : cilSave} />
                {isSaving ? 'Enviando...' : isSaved ? '¡Guardado con Éxito!' : 'Confirmar Validación'}
            </CButton>
        </div>
    );
};

export default FeedbackSemaphore;
